/**
 * Andre Garen - koleksiyon kapaklari (Tur 23 EK10 \u00a73.3; isaret snippets/ag-kapak.liquid). Yalniz kapak olan sayfada yuklenir.
 *  B027 "Bu hafta N yeni parca": son 7 gunde yayina alinan urun sayisi; bandla ayni kaynak ve onbellek
 *       (/collections/yeni-gelenler/products.json?limit=250, sessionStorage ag:yeni7, 30 dk). 0 ise satir gizli.
 *       Vapur oturumda bir kez soldan iskeleye gecer (6 sn, yalniz transform); hareket azaltmada iskelede sabit.
 *  B087 pano: cip basligi degistirince (ag:baslik olayi) harfler yeniden dizilir, donmeden.
 */
(function () {
  'use strict';
  if (window.AGKapak) return;
  window.AGKapak = true;
  var D = document.documentElement;
  var SAKIN = D.getAttribute('data-ag-calm') === '1' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---- B027 yeni parca sayisi ---- */
  var yeni = document.querySelector('[data-ag-kapak-yeni]');
  if (yeni) {
    var yaz = function (l) {
      var sinir = Date.now() / 1000 - 7 * 86400;
      var n = (l || []).filter(function (s) { return s >= sinir; }).length;
      if (n > 0) { yeni.textContent = 'Bu hafta ' + n + ' yeni par\u00e7a'; yeni.hidden = false; } else yeni.hidden = true;
    };
    var onb = null; try { onb = JSON.parse(sessionStorage.getItem('ag:yeni7') || 'null'); } catch (e) {}
    if (onb && Date.now() - onb.t < 18e5) yaz(onb.l);
    else fetch('/collections/yeni-gelenler/products.json?limit=250', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      var l = (j.products || []).map(function (p) { return Math.floor(Date.parse(p.published_at) / 1000); }).filter(function (x) { return !isNaN(x); });
      try { sessionStorage.setItem('ag:yeni7', JSON.stringify({ t: Date.now(), l: l })); } catch (e) {}
      yaz(l);
    }).catch(function () {});
  }

  /* ---- B027 vapur ---- */
  var vapur = document.querySelector('[data-ag-kapak-vapur]');
  if (vapur && !SAKIN) {
    var gordu = false; try { gordu = sessionStorage.getItem('ag:kapak-vapur') === '1'; sessionStorage.setItem('ag:kapak-vapur', '1'); } catch (e) {}
    if (!gordu) {
      vapur.style.setProperty('--yol', (vapur.offsetLeft + vapur.offsetWidth + 8) + 'px');
      vapur.classList.add('ag-kapak__vapur--gec');
    }
  }

  /* ---- B087 pano yeniden dizimi ---- */
  function satirlar(t) {
    var k = String(t || '').trim().replace(/-/g, ' ').split(/\s+/), s1 = '', s2 = '', iki = false, tasma = false;
    k.forEach(function (w) {
      if (!w) return;
      if (!iki) { var a = s1 ? s1 + ' ' + w : w; if (a.length <= 9) s1 = a; else { s2 = w; iki = true; } }
      else { var b = s2 + ' ' + w; if (b.length <= 9) s2 = b; else tasma = true; }
    });
    if (!s1 || s1.length > 9 || s2.length > 9) tasma = true;
    return tasma ? null : [s1, s2].filter(Boolean);
  }
  document.addEventListener('ag:baslik', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-ag-pano')) return;
    var t = el.textContent.trim(), l = satirlar(t);
    if (!l) return;
    el.textContent = '';
    var sr = document.createElement('span'); sr.className = 'ag-vh'; sr.textContent = t; el.appendChild(sr);
    l.forEach(function (s) {
      var sat = document.createElement('span'); sat.className = 'ag-pano__satir ag-pano--sabit'; sat.setAttribute('aria-hidden', 'true');
      Array.from(s).forEach(function (h) {
        var x = document.createElement('span');
        if (h === ' ') x.className = 'ag-pano__bos'; else { x.className = 'ag-pano__h'; x.textContent = h; }
        sat.appendChild(x);
      });
      el.appendChild(sat);
    });
  });
})();
